module.exports = __webpack_public_path__ + "media/images/static/data/DATA_MOBILE-cb3c3e722d44bb284e736a3f5478a8c7.png";